import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(public toastController: ToastController) {}

  async presentToast(info: string, time: number) {
    const toast = await this.toastController.create({
      message: info,
      duration: time
    });
    toast.present();
  }

  /*
  async presentToastWithOptions(title: string, info: string, time: number) {
    const toast = await this.toastController.create({
      header: title,
      message: info,
      position: 'top',
      buttons: [
        {
          side: 'start',
          icon: 'star',
          text: 'Favorite',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }
  */
}

